import * as types from './actionTypes';
export const listSatilanPolicelerRequest = (data) => ({
  type: types.LIST_SATILAN_POLICELER_REQUEST,
  payload: data,
});
